/*eslint-disable*/
import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import loginPageStyle from "assets/jss/material-kit-pro-react/views/loginPageStyle.js";
import image from "assets/img/bg7.jpg";
import {
	LoadingMgs,
	SuccessMessage,
	ErrorMessage,
} from "components/Common/toastify";
import { post } from "../../lib/requests";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setUser, logoutUser } from "redux/ducks/userSlice";
const useStyles = makeStyles(loginPageStyle);

export default function ResetPassword() {
	const classes = useStyles();
	const [loading, setLoading] = React.useState(false);
	const userDetails = useSelector((state) => state.user);
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const message = "Reset password";

	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;

		if (userDetails) {
			redirectLogin(userDetails);
		} else {
			navigate("/login");
		}
	}, []);

	const redirectLogin = (response) => {
		if (response.callnext == "login/mfa" || response.callnext == "login/pin") {
			navigate("/login-mfa");
			return;
		} else if (response.callnext == "") {
			if (userDetails?.csp) {
				// navigate("/csp-dashboard");
				window.location.href = "/csp-dashboard";
			} else {
				navigate("/dashboard");
			}
			return;
		}
	};

	// form validation rules
	const validationSchema = Yup.object().shape({
		password: Yup.string().required("Password is required"),
		confirm_password: Yup.string()
			.required("Confirm Password is required")
			.oneOf([Yup.ref("password"), null], "Passwords must match"),
	});
	const formOptions = { resolver: yupResolver(validationSchema) };

	// get functions to build form with useForm() hook
	const {
		register,
		handleSubmit,
		setError,
		setValue,
		reset,
		formState,
	} = useForm(formOptions);
	const { errors } = formState;

	async function onSubmit(formField) {
		setLoading(true);
		LoadingMgs(message, "processing...");
		try {
			await post("/api/user/resetpassword", formField, true)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage(message, `${message} operation done successfully`);
						const callnext = res.data.records.callnext;
						reset();
						if (callnext == "") {
							// navigate("/csp-dashboard");
							window.location.href = "/csp-dashboard";
							dispatch(setUser({ callnext }));
						} else if (callnext == "loginagain") {
							dispatch(logoutUser());
							navigate("/login");
						}
					} else {
						const mgs = res.data.errors.map((error) => {
							return error;
						});
						ErrorMessage(message, mgs);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage(message, message);
					setLoading(false);
				});
		} catch (error) {
			console.log("error", error);
			ErrorMessage(message, "Something went wrong try again!!");
			setLoading(false);
		}
	}

	return (
		<div>
			<Header
				absolute
				color="info"
				brand="Auscomp Cloud Services"
				links={<HeaderLinks dropdownHoverColor="info" />}
			/>
			<div
				className={classes.pageHeader}
				style={{
					backgroundImage: "url(" + image + ")",
					backgroundSize: "cover",
					backgroundPosition: "top center",
				}}>
				<div className={classes.container}>
					<GridContainer justify="center">
						<GridItem xs={12} sm={12} md={3}>
							<Card>
								<form
									onSubmit={handleSubmit(onSubmit)}
									id="myForm"
									className={loading ? classNames("opacity-40", classes.form) : ""}>
									<CardHeader color="info" signup className={classes.cardHeader}>
										<h4 className={classes.cartLabel}>Reset your password</h4>
									</CardHeader>
									<CardBody signup>
										<CustomInput
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												...register("password"),
												placeholder: "Enter password...",
												type: "password",
											}}
										/>
										<div className="text-red-600 text-xs ml-3 pt-1">
											{errors.password?.message}
										</div>
										<CustomInput
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												...register("confirm_password"),
												placeholder: "Confirm password...",
												type: "password",
											}}
										/>
										<div className="text-red-600 text-xs ml-3 pt-1">
											{errors.confirm_password?.message}
										</div>
									</CardBody>
									<div className={classes.textCenter}>
										<Button
											simple
											color="info"
											size="lg"
											type="submit"
											disabled={formState.isSubmitting}>
											Verify
										</Button>
									</div>
								</form>
							</Card>
						</GridItem>
					</GridContainer>
				</div>
			</div>
		</div>
	);
}
